import {
  ApiProperty,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';
import { UserCreatableInterface } from '../interfaces/user-creatable.interface';
import { UserDto } from './user.dto';
import { IsStrongPassword } from '../../auth/decorators/is-strong-password';

export class UserCreateDto
  extends IntersectionType(
    PickType(UserDto, [
      'idNumber',
      'firstName',
      'lastName',
      'email',
      'primaryPhone',
    ]),
    PartialType(PickType(UserDto, ['username', 'active'])),
  )
  implements UserCreatableInterface
{
  @ApiProperty()
  @IsStrongPassword()
  password!: string;
}
